<template>
  <div class="wrapper">
    <b-row>
      <b-col cols="12" style="display: flex; flex-wrap: wrap">
        <menu-list-item
          v-for="(item, key) in items"
          :key="key"
          :item="item"
          :column="column"
          :is-price-display="isPriceDisplay"
          :is-bikkurapon-icon-display="isBikkuraponIconDisplay"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MenuListItem from '@/components/menuList/MenuListItem'

export default {
  name: 'MenuList',
  components: { MenuListItem },
  props: {
    items: Array,
    column: null,
  },
  data() {
    return {
      displayData: [],
    }
  },
  computed: {
    ...mapGetters({
      getIsPreOrder: 'seat/getIsPreOrder',
      priceDisplayEnabled: 'seat/getPriceDisplayEnabled',
      bikkuraponIconDisplay: 'seat/getIsBikkuraponIconDisplay',
      preOrderPriceDisplayEnabled: 'shopDetail/getPriceDisplayEnabled',
      preOrderBikkuraponIconDisplay: 'shopDetail/getIsBikkuraponIconDisplay',
    }),
    isPriceDisplay() {
      return this.getIsPreOrder
        ? this.preOrderPriceDisplayEnabled === 1
        : this.priceDisplayEnabled === 1
    },
    isBikkuraponIconDisplay() {
      return this.getIsPreOrder ? this.preOrderBikkuraponIconDisplay : this.bikkuraponIconDisplay
    },
  },
}
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100%;
  padding-top: 10px;
  overflow-x: hidden;
}
</style>
